import { useTranslation } from 'react-i18next';

import type { BulkRefundSummary } from '../utils/bulk-refund-summary';

type Props = {
  summary: BulkRefundSummary;
};

/** The lines under a bulk refund toast: counts, then the reasons the failed payments gave. */
export function BulkRefundToastBody({ summary }: Props) {
  const { t } = useTranslation('payments');

  return (
    <div className="space-y-1">
      {summary.refunded > 0 && <p>{t('bulkRefund.refunded', { count: summary.refunded })}</p>}
      {summary.skipped > 0 && <p>{t('bulkRefund.skipped', { count: summary.skipped })}</p>}
      {summary.failedIds.length > 0 && <p>{t('bulkRefund.failed', { count: summary.failedIds.length })}</p>}
      {summary.reasons.length > 0 && (
        <ul className="list-disc pl-4">
          {summary.reasons.map((reason) => (
            <li key={reason.message}>
              {t('bulkRefund.reason', { count: reason.count, message: reason.message, interpolation: { escapeValue: false } })}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
